import {call, select} from "redux-saga/effects";
import {loginRedirectCheckData} from "store/reducer/auth/selectors";
import {calculateRedirectBasedOnAuth} from "services/utils/utils";
import {historyObject} from "historyObject";
import {resetCache} from "services/api/mocks";

export function* authRedirect() {
    const checkData = yield select(loginRedirectCheckData);
    const route = calculateRedirectBasedOnAuth(checkData);
    yield call(historyObject.replace, route);
    /* istanbul ignore next */
    if(process.env.REACT_APP_MOCKS) {
        resetCache();
    }
}